export default {
  variant: 'cards.primary',
  '@media (hover: hover) and (pointer: fine)': {
    ':hover': {
      transform: `translateY(-0.25rem)`,
      boxShadow: `0 0 25px rgba(140,152,164,.3)`
    }
  }
}
